import React, { ReactNode } from 'react';
import { Loading } from '../../components/commons/Loading';
import { useSplash } from '../../providers/splash/SplashProvider';

type Props = {
  loaders?: string[];
  children: ReactNode;
};

export const Splash = (props: Props) => {
  const { getIsReady } = useSplash();
  return getIsReady(props.loaders) ? <>{props.children}</> : <Loading />;
};
